module.exports = __webpack_public_path__ + "static/alex-928cdc6b47bc7ca00312a6f684362507.png";